export default "__VITE_ASSET__BhbEZl4d__"